import { render } from "./RegisterRecrut.vue?vue&type=template&id=f27e98fe&scoped=true"
import script from "./RegisterRecrut.vue?vue&type=script&lang=js"
export * from "./RegisterRecrut.vue?vue&type=script&lang=js"

import "./RegisterRecrut.vue?vue&type=style&index=0&id=f27e98fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27e98fe"]])

export default __exports__